export default function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/ascending.js
// module id = Fc3i
// module chunks = 0